import React from "react";
import { ParagraphMomento } from "@tumomento/ui";
import { useDimensions } from "@/hooks/useDimensions";
import "./Footer.scss";
import {
  APPS_FOOTER_MOMENTO,
  FOOTER_LINKS,
  LANDING_PAGE,
  SOCIAL_MEDIA_FOOTER_MOMENTO,
} from "@/constants";

export const Footer = () => {
  const { isMobile } = useDimensions();
  return (
    <footer className={`footer ${!isMobile && "flex justify-space-between"}`}>
      <img
        src={`${LANDING_PAGE}/images/logo-momento-footer.svg`}
        alt="Momento"
        className="footerLogo"
      />
      <div className="footerContainer">
        {FOOTER_LINKS.map(({ title, links }, index) => {
          return (
            <div
              key={`id-footer-${index}`}
              className={"footerContainerSection"}
            >
              <ParagraphMomento
                typography="body-m-semibold"
                color="content1"
                className={`pb-3 ${isMobile && "pt-3"}`}
              >
                {title}
              </ParagraphMomento>
              <ul className={"footerList"}>
                {links.map(({ color, linkText, link }, index) => {
                  return (
                    <li key={`id-footer-link-${index}`} className="pb-3">
                      <a href={link} className={`momento-text body-s ${color}`}>
                        {linkText}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
      <div className={`pb-12 ${isMobile && "pt-1 pb-12"}`}>
        <ParagraphMomento typography="body-m-semibold" color="content1">
          Síguenos en:
        </ParagraphMomento>
        <div className="pt-3">
          {SOCIAL_MEDIA_FOOTER_MOMENTO.map(
            ({ image, link, linkText }, index) => {
              return (
                <a
                  href={link}
                  key={`id-footer-social-media-${index}`}
                  className="me-3"
                  target="_blank"
                >
                  <img src={image} alt={linkText} width={24} height={24} />
                </a>
              );
            }
          )}
        </div>
        <div className={`apps pt-5 flex g-2`}>
          {APPS_FOOTER_MOMENTO.map(({ image, link, linkText }, index) => {
            return (
              <a href={link} key={`id-footer-apps-${index}`} target="_blank">
                <img src={image} alt={linkText} width={158} height={48} />
              </a>
            );
          })}
        </div>
      </div>
      <img
        src={`${LANDING_PAGE}/images/Otto.svg`}
        alt="Momento - Otto"
        className={"footerOtto"}
        width={72}
        height={83}
      />
    </footer>
  );
};
